import React from 'react'
import styled from 'styled-components'

const mode = process.env.REACT_APP_ENV_MODE

const colors = {
  test: { bg: '#ff8c00', text: '#fff' },
  live: { bg: '#2e7d32', text: '#fff' },
}

const Banner = styled.div`
  background: ${(props) => props.$bg};
  color: ${(props) => props.$color};
  text-align: center;
  padding: 4px 0;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  position: sticky;
  top: 0;
  z-index: 1100;
`

const EnvironmentBanner = () => {
  const config = colors[mode]
  if (!config) return null

  const label = mode === 'test' ? 'Test mode' : 'Live mode'

  return (
    <Banner $bg={config.bg} $color={config.text}>
      {label}
    </Banner>
  )
}

export default EnvironmentBanner
